import Vue from 'vue'
import App from './App.vue'
import VueRx from 'vue-rx'
import router from './router'
import store from './store'
import i18n from './plugin/vuei18n'
import scrollTo from 'vue-scrollto'

//load prism somewhere
import "prismjs";
import "prismjs/themes/prism.css";
//vue-prism-editor dependency
import "vue-prism-editor/dist/VuePrismEditor.css";

Vue.use(scrollTo, {
	offset: -60,
	duration: 600,
	easing: "ease",
});

Vue.use(VueRx);

Vue.config.productionTip = false;

new Vue({
	router,
	i18n,
	store,
	render: h => h(App),
}).$mount('#app');
